import React from 'react';
const ClientRequirements = () => <div className='p-6'><h1 className='text-2xl font-bold'>Submit Requirements</h1><p className='text-slate-500'>Coming soon...</p></div>;
export default ClientRequirements;
